import { BaseAppointmentAction, AppointmentActionContext, AppointmentMenuEntry, UserRole, isOffered } from "./base-action";
import { appointment_status } from "@/models/appointment.model";

class AppointmentActionRegistry {
    private actions = new Map<string, BaseAppointmentAction>();
    private menu = new Map<string, AppointmentMenuEntry>();

    register(action: BaseAppointmentAction): void {
        this.actions.set(action.config.id, action);
        this.menu.set(action.config.id, action);
    }

    offer(entry: AppointmentMenuEntry): void {
        this.actions.delete(entry.config.id);
        this.menu.set(entry.config.id, entry);
    }

    /**
     * Get an action by its ID
     */
    getAction(id: string): BaseAppointmentAction | undefined {
        return this.actions.get(id);
    }

    getAvailableActions(
        currentStatus: appointment_status,
        userRole: UserRole
    ): AppointmentMenuEntry[] {
        return [...this.menu.values()].filter((entry) => isOffered(entry.config, { currentStatus, userRole }));
    }

    /**
     * Execute an action by ID
     */
    async executeAction(
        actionId: string,
        context: AppointmentActionContext,
        payload?: any
    ) {
        const action = this.getAction(actionId);
        
        if (!action) {
            return {
                success: false,
                message: `Unknown action: ${actionId}`
            };
        }

        // Check if action is available for this context
        if (!action.isAvailable(context)) {
            return {
                success: false,
                message: "You don't have permission to perform this action"
            };
        }

        // Validate payload if action has validation
        const validationError = action.validatePayload(payload);
        if (validationError) {
            return {
                success: false,
                message: validationError
            };
        }

        return await action.execute(context, payload);
    }
}

// Export singleton instance
export const actionRegistry = new AppointmentActionRegistry();